// /** @jsx2 jsx2 */
// import { jsx } from '@emotion/core'
import React, { useState, useMemo, useContext } from 'react'
import {
  DatePicker,
  Button,
  Input,
  InputNumber,
  Select,
  Modal,
  message,
  Spin,
} from 'antd'
import moment from 'moment'
import R from 'ramda'
import styled from 'styled-components'
import { connect } from 'react-redux'
import {
  getUnits,
  getEventTypes,
  getUnitNameMap,
  getCauseCodeMap,
  getApiTargetInfo,
} from 'core'

import MultiCauseCodePropmt from 'card-data/MultiCauseCode'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { marginAnalysisSaveTicket } from 'api/pgads'
import { ErrorContext, SpinContext } from 'context'
import { Filler } from 'core/screen-util'

export const Labeled = styled.label`
  background-color: white;
  align-self: center;
  font-weight: 500;
  margin-top: 10px;
`

export const SubDiv = styled.div`
  margin-left: 5px;
  margin-bottom: 5px;
`

const eventDateFormat = 'YYYY-MM-DD HH:mm'

const timeZoneList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.timeZone])
)

const timeZoneOpt = unit =>
  R.compose(
    R.map(([_, text]) => ({ key: text, text, value: text })),
    R.sortBy(([_, text]) => text.toLowerCase()),
    R.filter(([key, _]) => key === unit),
    R.toPairs
  )

const unitCodeList = R.compose(
  R.fromPairs,
  R.map(a => [`${a.utility}${a.unit}`, a.id1])
)

const timeZoneOptionCall = (tList, unitsList, unit) => {
  // daylightSavings = 'Y' 'N'

  let daylightSavings = unitsList.find(u => u.unitId === unit) || {}

  daylightSavings = daylightSavings.daylightSavings || 'N'

  const list = timeZoneOpt(unit)(tList)
  if (list.length === 1 && daylightSavings !== 'N') {
    const zone = `${list[0].text.substring(0, 1)}D${list[0].text.substring(
      2,
      3
    )}`
    list.push({ key: zone, text: zone, value: zone })
  }
  return list
}

const setTimeZone = (date, timeZoneOptMap, unitsList, unit) => {
  let daylightSavings = unitsList.find(u => u.unitId === unit) || {}

  daylightSavings = daylightSavings.daylightSavings || 'N'

  // date.isDST false when calling secound time so nee to creat new moment
  return date && timeZoneOptMap.length > 0
    ? moment(
        moment(date).format('MM/DD/YYYY HH:mm'),
        'MM/DD/YYYY HH:mm'
      ).isDST() && daylightSavings === 'Y'
      ? (timeZoneOptMap[1] || {}).text || ''
      : timeZoneOptMap[0].text
    : ''
}

// remaining to check that unit is belongs to daylightsaving or not
const getGMTdate = date => {
  return date
    .clone()
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss')
}

const getDateStr = date => date.format('YYYY-MM-DDTHH:mm:SS')

const MarginCard97EditDialog = ({
  // WFSelectedEvent,
  units = [],
  eventTypes,
  unitNameMap,
  causeCodeMap,
  targetInfo,
  visible,
  onClose,
  type,
  lostType = '1',
}) => {
  const {
    WFSelectedEvent = {},
    setWFSelectedEvents,
    WFRetrieveData,
    // setWFRetrievedData,
    handleWFRetrieveData,
    selectedDateRangePicker,
  } = useContext(MarginAnalysisContext)

  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)

  const saveData = _ => {
    // eventstart ,eventend need to check
    // for new recore  , pass eventnum = null

    let {
      eventstartMoment,
      eventendMoment,
      eventstart,
      eventend,
    } = WFSelectedEvent

    eventstartMoment =
      (eventstartMoment && moment(eventstartMoment.format('YYYY-MM-DD'))) ||
      (eventstart && moment(eventstart, eventDateFormat))
    eventendMoment =
      (eventendMoment && moment(eventendMoment.format('YYYY-MM-DD'))) ||
      (eventend && moment(eventend, eventDateFormat))

    let isValidDate = false
    if (!eventstartMoment) {
      message.error('Please,Provide Event Start Date')
      return
    }

    const endDateCompare = moment(
      selectedDateRangePicker[1]
        .clone()
        .add(1, 'd')
        .hour(0)
        .minute(0)
        .format('YYYY-MM-DD')
    )

    if (
      eventstartMoment &&
      // eventstartMoment.isBetween(selectedDateRangePicker[0], endDateCompare)
      eventstartMoment.isAfter(selectedDateRangePicker[0]) &&
      eventstartMoment.isBefore(endDateCompare)
    )
      isValidDate = true
    if (
      eventendMoment &&
      eventendMoment.isBetween(selectedDateRangePicker[0], endDateCompare)
    )
      isValidDate = true

    if (
      !isValidDate &&
      (selectedDateRangePicker[0].isSame(eventstartMoment) ||
        selectedDateRangePicker[1].isSame(eventstartMoment) ||
        selectedDateRangePicker[0].isSame(eventendMoment) ||
        selectedDateRangePicker[0].isSame(eventendMoment))
    )
      isValidDate = true

    if (!isValidDate) {
      message.error('Event must be active during the what-if period')
      return
    }

    const sv = {
      responseData: {
        ...WFRetrieveData,
        request: { ...WFRetrieveData.request, lostType, mode: 'WHATIF' },
      },
      card97Ticket: {
        ...WFSelectedEvent,
        unitname: unitNameMap[WFSelectedEvent.unitId],
        eventstartGmt: WFSelectedEvent.eventstartGmt,
        eventendGmt: WFSelectedEvent.eventendGmt,
        causeDescrip: causeCodeMap[WFSelectedEvent.causecode],
        eventnum: type === 1 ? undefined : WFSelectedEvent.eventnum,
        year:
          WFSelectedEvent.year ||
          (eventstartMoment && eventstartMoment.format('YYYY')) ||
          selectedDateRangePicker[0].format('YYYY'),
      },
    }

    setSpinning(true)

    marginAnalysisSaveTicket(targetInfo)(sv).fork(setError, data => {
      setSpinning(false)
      handleWFRetrieveData(data, onClose)
      // onClose()
    })
  }

  const timeZoneListMap = useMemo(_ => timeZoneList(units), [units])

  const timeZoneOptionMap = useMemo(
    _ => timeZoneOptionCall(timeZoneListMap, units, WFSelectedEvent.unitId),
    [WFSelectedEvent.unitId, units, timeZoneListMap]
  )

  const {
    unit,
    // utility,
    unitId,
    eventnum,
    eventstart,
    eventstartMoment = eventstart && moment(eventstart, 'YYYY-MM-DD HH:mm'),
    eventend,
    eventendMoment = eventend && moment(eventend, 'YYYY-MM-DD HH:mm'),
    causecode = 0,
    eventtype,
    availcap,
    eventStartZone = setTimeZone(
      WFSelectedEvent.eventstart,
      timeZoneOptionMap,
      units,
      WFSelectedEvent.unitId
    ),
    eventEndZone = setTimeZone(
      WFSelectedEvent.eventend,
      timeZoneOptionMap,
      units,
      WFSelectedEvent.unitId
    ),
    description = '',
  } = WFSelectedEvent

  const unitCodeMap = useMemo(_ => unitCodeList(units), [units])

  const handleChange = ({ name, value }) => {
    setWFSelectedEvents({ ...WFSelectedEvent, [name]: value })
  }
  const handleChangeMultiple = cd =>
    setWFSelectedEvents({ ...WFSelectedEvent, ...cd })

  const [causeCodeDialogValues, setCauseCodeDialogValues] = useState({})

  const onCauseCodeDialogClose = (causeCodeKeyValues, causeCodeValues) => {
    setCauseCodeDialogValues({
      causeCodeDialog: false,
      causeCodeKeyValues,
      causeCodeValues,
      causecode: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : causecode,
    })

    handleChange({
      name: 'causecode',
      value: causeCodeValues
        ? causeCodeValues.length > 0
          ? causeCodeValues[0].causeCode
          : ''
        : causecode,
    })
  }

  const onCauseCodeTreeCancel = causeCodeKeyValues => {
    setCauseCodeDialogValues({
      causeCodeKeyValues,
      causeCodeDialog: false,
    })
  }

  const openCauseCodePrompt = d =>
    setCauseCodeDialogValues({
      // causeCodeKeyValues,
      causeCodeDialog: d,
    })

  return (
    <Modal
      maskClosable={false}
      title="Card97-Event Data"
      height={500}
      width={700}
      visible={visible}
      onCancel={onClose}
      okText={
        type === 1
          ? 'Create Ticket'
          : type === 2
          ? 'Save Ticket'
          : 'Delete Ticket'
      }
      onOk={saveData}
      destroyOnClose
      // afterClose={_ => setWFSelectedEvents({})}
      footer={
        <div style={{ display: 'flex' }}>
          <div>
            EventStart or EventEnd should be in range{' '}
            {selectedDateRangePicker[0].format('MM/DD/YYYY') +
              '  -  ' +
              selectedDateRangePicker[1].format('MM/DD/YYYY')}
          </div>
          <Filler />
          <Button onClick={onClose} loading={spinning}>
            Cancel
          </Button>
          <Button type="primary" onClick={saveData} loading={spinning}>
            {type === 1
              ? 'Create Ticket'
              : type === 2
              ? 'Save Ticket'
              : 'Delete Ticket'}
          </Button>
        </div>
      }
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gridColumnGap: '20px',
          }}
        >
          {/* <div style={{ height: '0px', width: '0px', gridColumn: 'span 3' }}>
          <Button onClick={saveData}>Save Ticket</Button>
        </div> */}
          <div style={{ height: '0px', width: '0px', gridColumn: 'span 3' }}>
            {causeCodeDialogValues.causeCodeDialog && (
              <MultiCauseCodePropmt
                key="card97editcausecodeprompt"
                // style={{ ...inlineStyle }}
                // checkable={false}
                visibleDialog={causeCodeDialogValues.causeCodeDialog}
                onDialogClose={onCauseCodeDialogClose}
                onCancelAction={onCauseCodeTreeCancel}
                selectedKeys={causeCodeDialogValues.causeCodeKeyValues}
                selectedValues={causeCodeDialogValues.causeCodeValues}
                // selectedValues={this.state.causeCodeValues || []}
                unitCodes={unitCodeMap ? [unitCodeMap[unitId]] : []}
                multiple={false}
                checkable={false}
                selectable
                causeCodeValue={[causecode]}
              />
            )}
          </div>
          <SubDiv>
            <Labeled>{'Event Number: '}</Labeled>

            <InputNumber
              style={{ width: '100%' }}
              key="eventnum"
              value={eventnum || '0'}
              placeholder="Event Number"
              name="eventnum"
              // min={0}
              // label="(Optional)"
              // labelPosition="right"
              onChange={value => handleChange({ name: 'eventnum', value })}
              // disabled={mode !== 'N'}
              disabled
            />
          </SubDiv>

          <div
            style={{
              gridRowEnd: 'span 3',
              gridColumnEnd: 'span 2',
              border: '1px solid lightgrey',
              padding: '2px 10px 10px',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridColumnGap: '30px',
              // gridTemplateRows: 'auto auto 30px auto 50px auto 30px auto',
            }}
          >
            <Labeled style={{ gridColumnEnd: 'span 2' }}>
              <span style={{ color: 'red' }}>*</span> {'Event Start: '}
            </Labeled>
            <DatePicker
              style={{}}
              // disabled={disableComp}
              // showTime
              // defaultValue={moment(eventstart).format('MM/DD/YYYY HH:mm') || ''}
              value={
                // WFSelectedEvent.eventstart &&
                eventstartMoment
                // moment(WFSelectedEvent.eventstart, 'YYYY-MM-DD HH:mm')
              }
              showTime={{
                format: 'h:mm',
                defaultValue: moment('00:00', 'HH:mm'),
              }}
              format="MM/DD/YYYY HH:mm"
              placeholder="Select DateTime"
              onChange={date => {
                handleChangeMultiple({
                  eventstartMoment: date,
                  eventStartZone: setTimeZone(
                    date,
                    timeZoneOptionMap,
                    units,
                    unitId
                  ),
                  eventstart: getDateStr(date),
                  eventstartGmt: getGMTdate(date),
                })
              }}
              onOk={date => {
                handleChangeMultiple({
                  eventstartMoment: date,
                  eventstart: getDateStr(date),
                  eventStartZone: setTimeZone(
                    date,
                    timeZoneOptionMap,
                    units,
                    unitId
                  ),
                  eventstartGmt: getGMTdate(date),
                })
              }}
            />
            <Select
              style={{ marginLeft: '5px' }}
              key="eventStartZone"
              // disabled={disableComp}
              value={
                eventStartZone ||
                setTimeZone(eventstart, timeZoneOptionMap, units, unitId) ||
                ''
              }
              placeholder="TimeZone"
              name="eventStartZone"
              onChange={value =>
                handleChange({ name: 'eventStartZone', value })
              }
              selection
              options={timeZoneOptionMap}
            >
              {timeZoneOptionMap.map(e => (
                <Select.Option key={e.value} value={e.value}>
                  {e.text}
                </Select.Option>
              ))}
            </Select>

            <Labeled style={{ gridColumnEnd: 'span 2', alignSelf: 'end' }}>
              {'Event End: '}
            </Labeled>
            <DatePicker
              style={{}}
              value={eventendMoment}
              showTime={{
                format: 'h:mm',
                defaultValue: moment('00:00', 'HH:mm'),
              }}
              format="MM/DD/YYYY HH:mm"
              placeholder="Select DateTime"
              onChange={date => {
                handleChangeMultiple({
                  eventendMoment: date,
                  eventEndZone: setTimeZone(
                    date,
                    timeZoneOptionMap,
                    units,
                    unitId
                  ),
                  eventend: getDateStr(date),
                  eventendGmt: getGMTdate(date),
                })
              }}
              onOk={date => {
                handleChangeMultiple({
                  eventendMoment: date,
                  eventEndZone: setTimeZone(
                    date,
                    timeZoneOptionMap,
                    units,
                    unitId
                  ),
                  eventend: getDateStr(date),
                  eventendGmt: getGMTdate(date),
                })
              }}
            />
            <Select
              style={{ marginLeft: '5px' }}
              key="eventEndZone"
              value={
                eventEndZone ||
                setTimeZone(eventend, timeZoneOptionMap, units, unit) ||
                ''
              }
              placeholder="TimeZone"
              name="eventEndZone"
              onChange={value => handleChange({ name: 'eventEndZone', value })}
              selection
              options={timeZoneOptionMap}
              // disabled={disableEndDate}
            >
              {timeZoneOptionMap.map(e => (
                <Select.Option key={e.value} value={e.value}>
                  {e.text}
                </Select.Option>
              ))}
            </Select>
          </div>

          <SubDiv>
            <Labeled>
              <span style={{ color: 'red' }}>*</span>
              {' Event Type: '}
            </Labeled>

            <Select
              showSearch
              style={{ width: '100%' }}
              key="eventtype"
              value={eventtype}
              placeholder="Event Type"
              // disabled={disableComp}
              name="eventtype"
              // onChange={handleChange}
              onChange={value => {
                if (value === 'RS') {
                  handleChangeMultiple({
                    eventtype: value,
                    description: 'Reserve Shutdown',
                    availcap: 0,
                    causecode: 0,
                  })
                } else if (value === 'IR') {
                  handleChangeMultiple({
                    eventtype: value,
                    description: 'Inactive Reserve',
                    availcap: 0,
                    causecode: 2,
                  })
                } else if (value === 'RU') {
                  handleChangeMultiple({
                    eventtype: value,
                    description: 'Retired',
                    availcap: 0,
                    causecode: 9990,
                  })
                } else if (value === 'MB') {
                  handleChangeMultiple({
                    eventtype: value,
                    description: 'Mothballed',
                    availcap: 0,
                    causecode: 9991,
                  })
                } else {
                  handleChange({ name: 'eventtype', value })
                }
              }}
              selection
              // options={eventTypes}
            >
              {(eventTypes || []).map(e => (
                <Select.Option value={e.eventType} key={e.eventType}>
                  {e.eventType}-{e.description}
                </Select.Option>
              ))}
            </Select>
          </SubDiv>
          <SubDiv>
            <Labeled>{'Net Available Cap: '}</Labeled>
            <InputNumber
              style={{ width: '100%' }}
              key="availcap"
              // type="number"
              // disabled={disableComp}
              value={availcap}
              placeholder="Net Available Cap"
              name="availcap"
              onChange={e => {
                handleChange({
                  name: 'availcap',
                  value: e,
                })
              }}
              min={0}
            />
          </SubDiv>
          <SubDiv>
            <Labeled>{'Cause Code: '}</Labeled>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '2fr 1fr',
                gridColumnGap: '10px',
              }}
            >
              <Input
                style={{
                  width: 'auto',
                  backgroundColor:
                    causecode >= 9180 && causecode <= 9199
                      ? 'rgb(194,57,237,0.5)'
                      : undefined,
                }}
                key="causecode"
                // disabled={disableComp}
                value={causecode}
                placeholder="Cause Code"
                name="causecode"
                min={-1}
                onChange={e =>
                  handleChange({
                    name: 'causecode',
                    value: e.target.value,
                  })
                }
              />
              <Button
                style={{ marginLeft: '5px' }}
                // disabled={disableComp}
                primary
                onClick={() => {
                  openCauseCodePrompt(true)
                  // if (unit === undefined || utility === undefined) {
                  //   message.info('Please, Select Utility and Unit')
                  //   return
                  // }
                }}
              >
                Select
              </Button>
            </div>
          </SubDiv>
          <SubDiv style={{ gridColumnEnd: 'span 3' }}>
            <Labeled style={{}}>{'Description: '}</Labeled>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto 150px',
                gridColumnGap: '50px',
              }}
            >
              <Input.TextArea
                allowClear
                key="description"
                placeholder="Description"
                name="description"
                value={description}
                onChange={e =>
                  handleChange({
                    name: 'description',
                    value: e.target.value,
                  })
                }
                autoHeight={false}
                rows={2}
              />
            </div>
          </SubDiv>
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({
  units: getUnits(state),
  eventTypes: getEventTypes(state),
  unitNameMap: getUnitNameMap(state),
  causeCodeMap: getCauseCodeMap(state),
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(MarginCard97EditDialog)
